<template>
    <site-img
        v-if="testimonials.length"
        class="md-testimonial grid-progressive"
        type="bgImg"
        :src="bgType == 'img' ? suitableImg : ''"
        :style="{ 'background-color': bgType == 'color' ? bgColor : null }"
        dir="width"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
        >
            <div class="title-container">
                <div v-if="title" class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
                <a
                    v-if="
                        moreText &&
                            (displayType == 'part' ||
                                defaultDisplayType == 'selected')
                    "
                    class="mg-more testimonials-show-more pc"
                    :href="useMoreHref"
                    :aria-label="useMoreHref"
                    :target="useMoreTarget"
                    rel="noopener noreferrer"
                >
                    <span class="to-view-more">
                        {{ moreText }}
                        <i class="iconfont icon-arrow-down"></i>
                    </span>
                </a>
            </div>
            <ul class="testimonial-list">
                <li
                    v-for="comment in testimonials"
                    :key="comment.id"
                    class="testimonial-item"
                    @click="()=>toViewMore(comment)"
                >
                    <img v-if="comment.rmaTrackPixelUrl" class="rma-pixel-img" :src="comment.rmaTrackPixelUrl" loading="lazy" :alt="comment.rmaTrackPixelUrl" />
                    <div class="testimonial-container">
                        <div
                            class="testimonial-context-empty-pic"
                            v-html="comment.reviewContent"
                        ></div>
                        <ReviewSourceLogo :sourceType="comment.sourceType" />
                    </div>
                    <div class="testimonial-content">
                        <div
                            class="intro-left"
                            aria-hidden="true"
                            v-if="comment.avatarLink"
                        >
                            <img-box :src="comment.avatarLink" />
                        </div>
                        <div class="intro-right">
                            <div
                                class="testimonial-name"
                                v-html="comment.reviewerName"
                            ></div>
                            <ReviewScore
                                :sourceType="comment.sourceType"
                                :score="comment.reviewRate"
                                :iconSize="16"
                                :iconSpace="14"
                            />
                        </div>
                    </div>
                </li>
            </ul>
            <a
                v-if="
                    moreText &&
                        (displayType == 'part' || defaultDisplayType == 'selected')
                "
                class="mg-more testimonials-show-more mobile"
                :href="useMoreHref"
                :aria-label="useMoreHref"
                :target="useMoreTarget"
                rel="noopener noreferrer"
            >
                <span class="to-view-more">
                    {{ moreText }}
                    <i class="iconfont icon-arrow-down"></i>
                </span>
            </a>
        </module-box>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </site-img>
</template>

<script>
import Common from '../index';
export default {
    mixins: [Common]
};
</script>
<style lang="scss">
@import './style.scss';
</style>
